import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { squadData } from "../../features/squad/squadSlice";
import styles from "./Squad.module.css";
import demo2 from "../../assets/images/download (1).jpeg";

const Squad = () => {
  const { match_id, match_status } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.squad.data);
  const pending = useSelector((state) => state.squad.pending);
  const error = useSelector((state) => state.squad.error);
  const finalData = data.data;
  const [teamA, setteamA] = useState(true);
  const [teamB, setteamB] = useState(false);

  const handleClick = (name) => {
    switch (name) {
      case "team_a":
        setteamA(true);
        setteamB(false);
        break;
      case "team_b":
        setteamA(false);
        setteamB(true);
        break;
      default:
        setteamA(true);
        setteamB(false);
    }
  };

  useEffect(() => {
    dispatch(squadData({ match_id: match_id, match_status: match_status }));
  }, [dispatch, match_id]);

  if (pending) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!finalData || data.status === false) {
    return <div>Squad will appear here as soon as we get that...</div>;
  }
  return (
    <div className={styles.squadWrapper}>
      <div className={styles.inning}>
        <div
          className={` ${teamA === true ? styles.active : styles.inactive} ${
            styles.inningNumber
          } `}
          onClick={() => {
            handleClick("team_a");
          }}
        >
          <span> {finalData?.team_a?.name} </span>
        </div>
        <div
          className={` ${teamB === true ? styles.active : styles.inactive} ${
            styles.inningNumber
          } `}
          onClick={() => {
            handleClick("team_b");
          }}
        >
          <span> {finalData?.team_b?.name} </span>
        </div>
      </div>

      {teamA ? (
        <div className={styles.teamASquadWrapper}>
          <div className={styles.squadListTeamA}>
            {finalData?.team_a?.player?.map((item, index) => (
              <div className={styles.playerData}>
                <div className={styles.playerImageContainer}>
                  <img
                    src={`https://images.weserv.nl/?url=${item.image}`}
                    alt=""
                  />
                </div>
                <h4>{item.name}</h4>
                <br />
                <span>{item.play_role}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={styles.teamBSquadWrapper}>
          <div className={styles.squadListTeamB}>
            {finalData?.team_b?.player?.map((item, index) => (
              <div className={styles.playerData}>
                <div className={styles.playerImageContainer}>
                  <img
                    src={`https://images.weserv.nl/?url=${item.image}`}
                    alt=""
                  />
                </div>
                <h4>{item.name}</h4>
                <br />
                <span>{item.play_role}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Squad;
